import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PricingOption {
  quantity: number;
  price: number;
  originalPrice?: number;
  label?: string;
  popular?: boolean;
  features?: string[];
}

interface PricingTablePreviewProps {
  settings: {
    title?: string;
    subtitle?: string;
    options?: PricingOption[];
    currency?: string;
    buttonText?: string;
    buttonColor?: string;
    buttonTextColor?: string;
    cardBackgroundColor?: string;
    popularColor?: string;
    textColor?: string;
  };
}

export const PricingTablePreview = ({ settings }: PricingTablePreviewProps) => {
  const defaultOptions: PricingOption[] = [
    { quantity: 1, price: 500, originalPrice: 1000, label: "قطعة واحدة" },
    { quantity: 2, price: 800, originalPrice: 2000, label: "قطعتين", popular: true, features: ["وفر 600 جنيه", "شحن مجاني"] },
    { quantity: 3, price: 1000, originalPrice: 3000, label: "3 قطع", features: ["وفر 2000 جنيه", "شحن مجاني", "هدية مجانية"] },
  ];

  const options = settings.options || defaultOptions;

  return (
    <div className="py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-3" style={{ color: settings.textColor || "#000" }}>
          {settings.title || "اختر الباقة المناسبة لك"}
        </h2>
        {settings.subtitle && (
          <p className="text-center text-lg mb-8 opacity-80">
            {settings.subtitle}
          </p>
        )}

        <div className="grid md:grid-cols-3 gap-6">
          {options.map((option, index) => (
            <div
              key={index}
              className={`rounded-2xl p-6 border-2 transition-all hover:shadow-xl ${
                option.popular ? "border-green-500 scale-105" : "border-gray-200"
              }`}
              style={{
                backgroundColor: settings.cardBackgroundColor || "#ffffff",
                color: settings.textColor || "#000000",
              }}
            >
              {option.popular && (
                <div
                  className="text-center text-sm font-bold py-1 px-3 rounded-full mb-4 inline-block"
                  style={{
                    backgroundColor: settings.popularColor || "#10b981",
                    color: "#ffffff",
                  }}
                >
                  الأكثر مبيعاً ⭐
                </div>
              )}

              <div className="text-center mb-6">
                <div className="text-2xl font-bold mb-2">
                  {option.label || `${option.quantity} قطع`}
                </div>
                {option.originalPrice && (
                  <div className="text-sm line-through opacity-60">
                    {option.originalPrice} {settings.currency || "جنيه"}
                  </div>
                )}
                <div className="text-4xl font-bold" style={{ color: settings.buttonColor || "#10b981" }}>
                  {option.price} {settings.currency || "جنيه"}
                </div>
              </div>

              {option.features && option.features.length > 0 && (
                <div className="space-y-3 mb-6">
                  {option.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              )}

              <Button
                className="w-full py-6 text-lg"
                style={{
                  backgroundColor: settings.buttonColor || "#10b981",
                  color: settings.buttonTextColor || "#ffffff",
                }}
              >
                {settings.buttonText || "اطلب الآن"}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
